<template>
    <v-overlay :value="openOverlay" opacity="1" color="#212121">
        <v-progress-circular indeterminate color="primary" size="100" width="4">
            <v-img eager :src="require('@/assets/img/logo_loader.png')" height="80" contain class="logo"/>
        </v-progress-circular>
    </v-overlay>
</template>

<script>

import firebase from 'firebase/app'
import 'firebase/auth'

import {mapState, mapMutations, mapActions} from 'vuex'

export default {
    data() {
        return {
            openOverlay: true,
            ok: false,
            isNew: false,
            delay: 1000
        }
    },
    mounted() {
        const vm = this
        vm.setLoadingUser(true)
        setTimeout(() => {
            vm.loadApp()
        }, vm.delay)
    },
    computed: mapState(['loadingUser']),
    methods: {
        ...mapMutations(['setCurrentUser', 'setLoadingUser']),
        ...mapActions(['initUser']),
        async loadApp() {
            const vm = this
            try {
                const user = firebase.auth().currentUser
                if (!user) {
                    console.log('no firebase user', user)
                    vm.ok = false
                    vm.setCurrentUser(null)
                    vm.setLoadingUser(false)
                    return
                }

                vm.isNew = user.metadata.creationTime === user.metadata.lastSignInTime
                vm.ok = true
                await vm.initUser(user)
            } catch (error) {
                console.log('firebase error', error)
                vm.ok = false
                vm.setCurrentUser(null)
                vm.setLoadingUser(false)
            }
        },
        close() {
            const vm = this

            setTimeout(() => {
                vm.openOverlay = false
            }, vm.delay)

            setTimeout(() => {
                vm.$emit(vm.ok ? 'success' : 'error', this.isNew)
            }, vm.delay + 500)
        }
    },
    watch: {
        loadingUser(val) {
            const vm = this
            if (!val) vm.close()
        }
    }
}

</script>


<style scoped>

.logo {
    display: flex;
    flex-direction: row;
    z-index: 999;
}

</style>
